import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3213672e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["toggle-button", { on: $props.isOn }]),
      type: "button",
      onClick: $setup.onClickToggleButton
    }, _toDisplayString($props.title), 3 /* TEXT, CLASS */)
  ]))
}